import React from 'react';
import '../../App.css';


export default function Numeros() {
    return <>
        <body className='numeros'>
            <h1 className='title'>Hemopets em N&uacute;meros</h1>
            <h1> Pets Cadastrados: 2</h1>
            <h1> Cl&iacute;nicas Cadastradas: 1</h1>
        </body>
    </>;
}